(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.RightBridgeReturn",
            {
                url: "/RightBridgeReturn",
                component: "rightBridgeReturn",
            });
    }]);

    app.component("rightBridgeReturn",
        {
            templateUrl: "/App/Transaction/RightBridgeReturn/template.html",
            controller: rightBridgeReturnController,
            bindings: {
            }
        });

    rightBridgeReturnController.$inject = [
        "$state", "$scope", "transactionApi", "$q", "$location", "_", "rightBridgeApi", "arcEnrollments", "arcEnrollmentsApi"
    ];

    function rightBridgeReturnController($state, $scope, transactionApi, $q, $location, _, rightBridgeApi, arcEnrollments, arcEnrollmentsApi) {
        var $ctrl = this;
                      
        ng.extend($ctrl,
            {
                UI: { loading: true },
                goToProductShelf: goToProductShelf,
                goToDocumentUpload: goToDocumentUpload,
                activateRightBridgeSso: activateRightBridgeSso

            });

        function goToProductShelf() {
            $state.go("Transaction.Determine.ProductShelf", { transactionId: $ctrl.transaction.Id });;
        };

        function goToDocumentUpload() {
            $state.go("Transaction.Determine.Documents", { transactionId: $ctrl.transaction.Id });
        };
        
        function getRightBridgeResponse(transactionId) {
            return transactionApi.getTransactionRightBridgeResponse(transactionId);
        }

        function activateRightBridgeSso() {
            var w = window;
            w.document.write("Loading...");
            rightBridgeApi.initiateRightBridgeSso($ctrl.transaction.Id).then(function (data) {
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

        this.$onInit = function() {
            var externalIdentifier = $location.search().Id;

            if (externalIdentifier) {
                $ctrl.UI = {};
                $ctrl.transaction = {};
                $ctrl.responseCusips = [];

                transactionApi.getTransactionFromExternalIdentifier(externalIdentifier).then(function (transactionIds) {
                    if (transactionIds) {
                        transactionApi.get(transactionIds.TransactionId).then(function (data) {
                            $ctrl.transaction = data;
                            $scope.$parent.$ctrl.getCurrentStage($state);
                            $ctrl.UI.HasRetireUp = $ctrl.transaction.DeterminePoints.includes("Rightbridge");

                            getRightBridgeResponse($ctrl.transaction.Id).then(function (data) {

                                try {
                                    var rbJsonData = JSON.parse(data.JsonData);
                                    var vars = _.map(rbJsonData, "vars")[0];
                                    var varSets = _.map(vars, "varSet");
                                    _.find(varSets, function (vSetRow) {
                                        if (vSetRow.name === "AWSelectedProductIncome" || vSetRow.name === "AWSelectedProductAccumulation") {
                                            _.find(vSetRow.vars, function (v) {
                                                if (v.var.name === "Cusip") {
                                                    var cusips = v.var.value.split("|");
                                                    ng.forEach(cusips, function (c) {
                                                        if (c.length)
                                                            $ctrl.responseCusips.push(c);
                                                    });
                                                }
                                            });
                                        }
                                    });
                                } catch (e) {
                                    console.log("Error parsing Rightbridge Json data");
                                }
                            }).catch(function (e) {

                            }).then(function () {
                                if ($ctrl.responseCusips.length) {
                                    if ($ctrl.responseCusips[0].length > 0) {
                                        goToProductShelf();
                                    }
                                }

                                $ctrl.UI.loading = false;
                            });
                        });
                    }

                    else $state.go("Home.ViewTransactions");
                });
            }

            else $state.go("Home.ViewTransactions");
        };
    }
})(window.app, window.angular);